import styled, { css } from 'styled-components'
import { Row } from '@sainsburys-tech/bolt'
import { colorSelector, colorToLunaToken, createCSSObject } from '../theming/utilities'
import { themeContract } from './ImageCtaCard.theme.contract'
import { TextWrapper } from '../StyledWrappers.styles'
import { ImageCtaCardImageContainer, ImageCtaCardLogoImage, ImageCtaCardHeading, ImageCtaCardBody } from './types'

const imgRatio = (ratio) => ratio.replace(':', '/')

const padding = (subheading) => ({
  left: subheading ? '5px 25px 16px' : '5px 25px',
  center: '5px 10px'
})

const StyledContainer = styled(Row)`
  text-align: center;
  border: none;
  border-radius: ${(props) => props.theme.size.border.radius.base};
  text-decoration: none;
  background-color: ${(props) =>
    props.theme.color.monochrome[themeContract[props.theme.channel].bodyCopy.backgroundColor]};
  justify-content: flex-start;
  overflow: hidden;
  min-width: 100%;
  width: 100%;
  height: 100%;
  position: relative;
`

const StyledImageContainer = styled.div<ImageCtaCardImageContainer>`
  width: 100%;
  position: relative;
  overflow: hidden;
  ${(props) =>
    css`
      aspect-ratio: ${imgRatio(props.imageRatio)};
      max-height: ${props.imageStyle === 'normal' || props.imageStyle === 'short' ? '250px' : 'unset'};

      @media screen and (min-width: ${props.theme.size.breakpoint['min-width'].sm}) and (max-width: ${props.theme.size
          .breakpoint['max-width'].md}) {
        aspect-ratio: ${imgRatio(props.gridTabletRatio)};
      }
    `}

  img {
    height: 100%;
    max-width: 100%;
    width: auto;
  }

  ${(props) =>
    (props.imageStyle === 'normal' || props.imageStyle === 'short') &&
    !props.container.includes('c004') &&
    css`
      height: 100%;
      padding-top: 0;
    `}
  ${(props) =>
    props.citrus &&
    css`
      background-color: ${props.backgroundColor};
    `}

    ${(props) =>
    props.imageStyle === 'icon' &&
    css`
      && {
        padding-top: ${props.theme.size.spacing.lg};
        min-height: 40px;
        max-height: 150px;
      }
    `}
`

const StyledBody = styled(Row)<ImageCtaCardBody>`
  ${TextWrapper}
  justify-content: center;
  min-height: 55px;
  padding: ${(props) => (props.hasLogo ? '0' : padding(props.hasSubheading)[props.textAlignment])};
  background-color: ${(props) =>
    props.theme.color.monochrome[themeContract[props.theme.channel].bodyCopy.backgroundColor]};
`

const StyledBodyCopy = styled.div`
  color: ${(props) => props.theme.color.monochrome[themeContract[props.theme.channel].bodyCopy.color]};
  margin-bottom: 0;
  white-space: normal;
`

const StyledLogoImage = styled.div<ImageCtaCardLogoImage>`
  display: flex;
  justify-content: center;
  height: 80px;
  max-height: 80px;
  width: 100%;
  background-color: ${(props) => colorToLunaToken(props.backgroundColor, props.theme)};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
`

const StyledHeading = styled.p<ImageCtaCardHeading>`
  && {
    margin: 0;
    white-space: normal;
    ${(props) =>
      css`
        ${createCSSObject(props.theme.font.stack['label-2'])}
        color: ${colorSelector(
          props.textColor,
          props.theme.color.palette[themeContract[props.theme.channel].heading.color],
          props.theme
        )};
        margin-bottom: ${themeContract[props.theme.channel].heading.marginBottom};
      `}

    ${(props) =>
      props.isOffer &&
      css`
        color: ${props.theme.color.content.sale};
      `};
  }
`

const StyledLegalCopy = styled.p`
  ${(props) => css`
    ${createCSSObject(props.theme.font.stack.caption)}
    margin-top: auto;
    && {
      margin-bottom: 0;
      line-height: ${props.theme.font['line-height']['display-6']};
    }
    padding: ${props.theme.size.spacing.sm} ${props.theme.size.spacing.md};
    text-align: left;
  `}
`

export {
  StyledContainer,
  StyledImageContainer,
  StyledBody,
  StyledBodyCopy,
  StyledLogoImage,
  StyledHeading,
  StyledLegalCopy
}
